module.exports = "https://dev.stanwinstonschool.com/deadpool.5cf42be6c2cefcbc828f552616f625fe.jpg";